import { render, staticRenderFns } from "./inventoryVerification.vue?vue&type=template&id=563182cc&scoped=true&"
import script from "./inventoryVerification.vue?vue&type=script&lang=js&"
export * from "./inventoryVerification.vue?vue&type=script&lang=js&"
import style0 from "./inventoryVerification.vue?vue&type=style&index=0&id=563182cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563182cc",
  null
  
)

export default component.exports